import React, { Fragment, useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Row, Label, Input, FormGroup, FormFeedback } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import MomentUtils from '@date-io/moment';
import ModalUI from '../../../shared/components/Modal';
import moment from 'moment';

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#000"
        },
    },
});

const no_op = () => { }
const FormAddPayment = ({ refresh = no_op, selectedInvoice, paymentToEdit, onEdit, setOnEdit = no_op, incomeToPay = '' }) => {
    const [errors, setErrors] = useState({});
    const [incomeValue, setIncomeValue] = useState('');
    const [idTransaction, setIdTransaction] = useState('');
    const [paymentDate, setPaymentDate] = useState(new Date());
    const [paymentWay, setPaymentWay] = useState('');
    const [note, setNote] = useState('');
    //const [payments, setPayments] = useState([])


    const [openAlert, setOpenAlert] = useState(false);
    const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });

    useEffect(() => {
        console.log("REFRESH", refresh, paymentToEdit, onEdit, selectedInvoice);
        if (onEdit) {
            setIncomeValue(paymentToEdit.importe);
            setIdTransaction(paymentToEdit.transaccion);
            setPaymentDate(paymentToEdit.fecha_pago);
            setPaymentWay(paymentToEdit.forma_pago);
            setNote(paymentToEdit.nota);
        } 
    }, [paymentToEdit, onEdit])

    useEffect(() => {
      if(!onEdit){
         //setIncomeValue('');
         setIncomeValue(incomeToPay);
         setIdTransaction('');
         setPaymentDate(new Date());
         setPaymentWay('');
         setNote('');
      } 
    }, [incomeToPay])
    


    const validateForm = () => {
        const errors = {};
        var error = false;
        if (incomeValue == "") {
            errors.valor_ingresado = "Ingrese el importe recibido";
            error = true;
        }

       /*  if (parseInt(incomeValue) > selectedInvoice.total) {
            errors.importe = "El importe ingresado supera al total de la factura";
            error = true;
        } */

        if (paymentDate == null) {
            errors.fecha = "Seleccione una fecha";
            error = true;
        }


        if (paymentWay == '') {
            errors.forma_pago = "Seleccione una forma de pago";
            error = true;
        }
        
       /*  if(errors.hasOwnProperty('importe')){
            setModalAlert({
                message: errors.importe,
                color: 'danger',
                title: "Error!"
            });
        } */
        console.log("ERRORSFORM", errors);
        setErrors(errors);
        return error;
    }

    const savePayment = async () => {

        if (!validateForm()) {
            let dataSend = {
                importe: parseInt(incomeValue),
                transaccion: idTransaction,
                fecha_pago: moment(paymentDate).format('YYYY-MM-DD HH:mm:ss'),
                forma_pago: paymentWay,
                nota: note,
                id_factura_t: selectedInvoice.id_factura_t,
                retencion: false,
                portentaje_info: null,
                tipo_retencion: null
            }

            await fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then((response) => {
                    if (response.status != 500 && response.status != 403) {
                        return response.text();
                    }
                    else {
                        throw new Error(response.text());
                    }
                })
                .then((data) => {
                    console.log("PaymentSaved", data);
                    setIncomeValue('');
                    setIdTransaction('');
                    setPaymentDate(new Date());
                    setPaymentWay('');
                    setNote('');
                    refresh();
                    setOpenAlert(true);
                    setModalAlert({
                        message: "Guardado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    });
                    //setPayments([...payments, dataSend]);
                })
                .catch((error) => {
                    console.log(error)
                    setModalAlert({
                        message: "No se pudo guardar el pago",
                        color: 'danger',
                        title: "Error!"
                    });
                })
        }
    }

    const updatePayment = async () => {

        if (!validateForm()) {
            let dataSend = {
                importe: parseInt(incomeValue),
                transaccion: idTransaction,
                fecha_pago: moment(paymentDate).format('YYYY-MM-DD HH:mm:ss'),
                forma_pago: paymentWay,
                nota: note,
                id_pago: parseInt(paymentToEdit.id_pago),
                retencion: false,
                portentaje_info: null,
                tipo_retencion: null
            }

            await fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/update', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then((response) => {
                    if (response.status != 500 && response.status != 403) {
                        return response.text();
                    }
                    else {
                        throw new Error(response.text());
                    }
                })
                .then((data) => {
                    setIncomeValue('');
                    setIdTransaction('');
                    setPaymentDate(new Date());
                    setPaymentWay('');
                    setNote('');
                    setOnEdit(false);
                    refresh();
                    console.log("PaymentUpdated", data);
                    setOpenAlert(true);
                    setModalAlert({
                        message: "Pago Actualizado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    });
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }


    return (
        <Fragment>
            <Row>
                <Col md={6}>
                    <TextField
                        label="Importe recibido"
                        required
                        value={incomeValue}
                        onChange={(event) => {
                            setIncomeValue(event.target.value)
                        }}
                        type="number"
                        className="medical-material-form__field"
                        error={errors.hasOwnProperty("valor_ingresado") ? errors.valor_ingresado !== "" : false}
                        helperText={errors.valor_ingresado}
                    />
                </Col>
                <Col md={6}>
                    <TextField
                        label="Id de la transacción"
                        value={idTransaction}
                        onChange={(event) => {
                            setIdTransaction(event.target.value)
                        }}
                        type="text"
                        className="medical-material-form__field"
                        error={errors.hasOwnProperty("id_transaccion") ? errors.id_transaccion !== "" : false}
                        helperText={errors.id_transaccion}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                        <ThemeProvider theme={defaultMaterialTheme}>
                            <KeyboardDatePicker
                                required
                                label="Fecha de pago"
                                openTo="date"
                                variant="inline"
                                value={paymentDate}
                                onChange={(date) => {
                                    setPaymentDate(date);
                                }}
                                format="DD/MM/YYYY"
                                animateYearScrolling
                                className="material-form__field"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                autoOk={true}
                                style={{ width: '100%' }}
                                error={errors.hasOwnProperty("fecha") ? errors.fecha !== "" : false}
                                helperText={errors.fecha}
                            />
                        </ThemeProvider>
                    </MuiPickersUtilsProvider>
                </Col>
                <Col md={6}>
                    <TextField
                        label="Forma de pago"
                        required
                        select
                        value={paymentWay}
                        onChange={(event) => {
                            setPaymentWay(event.target.value)
                        }}
                        type="number"
                        className="medical-material-form__field"
                        error={errors.hasOwnProperty("forma_pago") ? errors.forma_pago !== "" : false}
                        helperText={errors.forma_pago}
                    >
                        <MenuItem key={1} value={'Efectivo'}>
                            Efectivo
                        </MenuItem>
                        <MenuItem key={2} value={'Tarjeta'}>
                            Tarjeta
                        </MenuItem>
                        <MenuItem key={3} value={'Cheque'}>
                            Cheque
                        </MenuItem>
                    </TextField>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <TextField
                        label="Nota"
                        multiline
                        maxRows={4}
                        value={note}
                        onChange={(event) => {
                            setNote(event.target.value)
                        }}
                        type="number"
                        className="medical-material-form__field"
                        error={errors.hasOwnProperty("nota") ? errors.nota !== "" : false}
                        helperText={errors.nota}
                    />
                </Col>
                <Col md={6}>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ marginRight: 10, marginTop: 10 }}
                            color="primary"
                            size="sm"
                            id="searchBtn"
                            onClick={() => {
                                if (onEdit) {
                                    updatePayment();
                                } else {
                                    savePayment();
                                }
                            }}
                        >
                            {onEdit ? 'Actualizar' : 'Guardar'}
                        </Button>
                    </div>
                </Col>
            </Row>
            {openAlert ?
                <ModalUI
                    color={modalAlert.color}
                    title={modalAlert.title}
                    message={modalAlert.message}
                    modal={openAlert}
                    toggle={() => { setOpenAlert(!openAlert) }}
                    onOk={() => { setOpenAlert(!openAlert) }}
                /> : null}
        </Fragment>
    )
}

export default FormAddPayment